import { Components } from '@mui/material';
import { grey } from '@mui/material/colors';

export const MuiAvatar: Components['MuiAvatar'] = {
  styleOverrides: {
    colorDefault: { backgroundColor: grey[100] },
  },
};
